import React, { useEffect, useState } from 'react';
import { useQueryParams } from 'core/hooks/useQueryParams';
import {
  AuthLoader,
  oAuthStorage,
  recoverFromFailedSignIn,
  restartSignIn,
  setCognitoUserSession
} from 'core/components/auth';
import { describeDeepLink } from 'core/components/auth/deep-link-analytics';
import { track } from 'core/helpers/analytics';
import ErrorDialog from 'core/components/error-dialog/error-dialog';
import { brandConstants } from 'brand-config';

const OAuthResponse = () => {
  const { code, state, error, error_description } = useQueryParams();
  const [exchangeFailed, setExchangeFailed] = useState(false);

  useEffect(() => {
    // Cognito returns either code+state or error+error_description, never both
    if (code && state) {
      // Scrub the spent code from the address bar first, so reload, bookmark and session
      // restore can't replay it against Cognito (#35646)
      window.history.replaceState(null, '', window.location.pathname);
      setCognitoUserSession(code, state).then(({ status }) => {
        if (status === 'failed') {
          setExchangeFailed(true);
        }
      });
    } else if (error_description) {
      track('Staff Sign In Failed', {
        failureSource: 'cognito-oauth',
        errorCode: error,
        errorMessage: error_description,
        ...describeDeepLink(oAuthStorage.peekDeepLink())
      });
    } else {
      // No callback params (e.g. a reload after the URL was scrubbed) — nothing to exchange
      recoverFromFailedSignIn();
    }
  }, []);

  // Cognito redirected back with an error, or the token exchange failed with no session to
  // fall back on — either way tell the user instead of leaving them on the loader
  if (error_description || exchangeFailed) {
    return (
      <ErrorDialog
        open
        onClose={restartSignIn}
        title="Authentication Error"
        errors={[error_description || "We couldn't complete sign-in. Please try again or reach out to support."]}
        showGoHomeButton={false}
        secondaryLabel="Email support"
        onSecondaryClick={() => {
          window.location.href = `mailto:${brandConstants.AGENCY_SUPPORT_EMAIL}`;
        }}
        label="Try again"
        onClick={restartSignIn}
      />
    );
  }

  return <AuthLoader />;
};

export default OAuthResponse;
